/**
 * @param {unknown} object данные которые необходимо проверить на объект
 * @returns {boolean}
 */
const isObject = (object: unknown): boolean =>
    typeof object === 'object' && !Array.isArray(object) && object !== null;

export default isObject;
